import UploadService from "../services/UploadService"
import React  from "react"

const Image = ({upload, fullSize}) => {
    const [image, setImage]= React.useState()


    React.useEffect( ()=> {
        const fetchData= async() => {
            if (upload.id < 0) {
                setImage(Buffer.from(upload.base64))
            } else {
                var response
                if (!fullSize) {
                    response= await UploadService.getThumb(upload.id)
                } else {
                    response= await UploadService.getImage(upload.id)
                }
                setImage(URL.createObjectURL(response.data))
            }
    
        }
            fetchData()
    }, [upload.id, upload.base64, fullSize])
    return (
            <img src={image} style={{width:'100%', height:' 100%', objectFit: 'contain'}} alt='' />
    )
}

export default Image